import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';
import { allAdditionalArticles } from '@/mocks/articles-index';

export default function FooterSection() {
  const firstCol = categories.slice(0, 3);
  const secondCol = categories.slice(3, 6);
  const thirdCol = categories.slice(6, 9);
  const fourthCol = categories.slice(9, 14);

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10 md:gap-6">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="text-xl font-heading font-semibold tracking-tight text-background-50 whitespace-nowrap"
            >
              oopbuyspread<span className="text-accent-400">.</span>boats
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-xs">
              Der vertrauenswürdige Einkaufsbegleiter für modebewusste Käufer in Deutschland. Alle 14 Kategorien auf einen Blick.
            </p>
          </div>

          {/* Kategorien */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Kategorien</h4>
            <ul className="space-y-2.5">
              {firstCol.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {cat.nameDe}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Fashion */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Fashion</h4>
            <ul className="space-y-2.5">
              {secondCol.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {cat.nameDe}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Accessoires */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Accessoires</h4>
            <ul className="space-y-2.5">
              {thirdCol.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {cat.nameDe}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Mehr */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Mehr</h4>
            <ul className="space-y-2.5">
              {fourthCol.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {cat.nameDe}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Ratgeber */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Ratgeber</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-guide-deutschland" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  Ultimativer Guide
                </Link>
              </li>
              {allAdditionalArticles.slice(0, 4).map((article) => (
                <li key={article.slug}>
                  <Link to={`/artikel/${article.slug}`} className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    {article.title.length > 35 ? article.title.slice(0, 35) + '...' : article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-8 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} oopbuyspread.boats – Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-background-500 hover:text-background-200 transition-colors">
              Startseite
            </Link>
            <Link to="/artikel/oopbuy-spreadsheet-guide-deutschland" className="text-xs text-background-500 hover:text-background-200 transition-colors">
              Guide
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-500 hover:text-background-200 transition-colors"
            >
              oopbuy spreadsheet
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}